import React, { useEffect, useState } from 'react'
import { Select } from '../Select'
import { useGlobal } from '../../../contexts/GlobalContext'

import {
  Container,
  SelectWrapper,
  Option
} from './styles'

export const FilterCategory = (props) => {
  const {
    filterValues,
    handleChangeFilterCategory,
    setFilterValues
  } = props

  const { invokeServer } = useGlobal()

  const [categoryList, setCategoryList] = useState([])
  const [depth0Options, setDepth0Options] = useState([])
  const [depth1Options, setDepth1ptions] = useState([])
  const [depth2Options, setDepth2Options] = useState([])

  const getOptionList = (name, list) => {
    const depthOptions = list.filter((value, index, self) => {
      return self.findIndex(item => item[`${name}`] === value[`${name}`]) === index
    }).map((item, i) => {
      return {
        value: item[`${name}`] || i,
        content: <Option>{item[`${name}`]}</Option>
      }
    })
    depthOptions.unshift({ value: 'all', content: <Option>All</Option> })
    return depthOptions
  }

  const getCategoryList = () => {
    invokeServer('get', '/api/nft_category?all=')
      .then(r => {
        if (r.data.result === 1) {
          let depth0List = getOptionList('depth0', r.data.categories)
          setDepth0Options(depth0List)
          setCategoryList(r.data.categories)
        }
      })
      .catch(err => {
        console.log(`${err.message}`);
      })
  }

  useEffect(() => {
    const _categoryList = categoryList.filter(item => item.depth0 === filterValues?.category?.depth0)
    const depth1List = getOptionList('depth1', _categoryList)
    setDepth1ptions(depth1List)
    const _category = { ...filterValues.category, depth1: 'all', depth2: 'all'}
    setFilterValues({ ...filterValues, category: _category })
  }, [filterValues?.category?.depth0])

  useEffect(() => {
    const _categoryList = categoryList.filter(item => (item.depth0 === filterValues?.category?.depth0 && item.depth1 === filterValues?.category?.depth1))
    const depth2List = getOptionList('depth2', _categoryList)
    setDepth2Options(depth2List)
    const _category = { ...filterValues.category, depth2: 'all'}
    setFilterValues({ ...filterValues, category: _category })
  }, [filterValues?.category?.depth1])

  useEffect(() => {
    getCategoryList()
  }, [])

  return (
    <Container>
      <SelectWrapper isTop>
        <Select
          notReload
          options={depth0Options}
          placeholder='Select category'
          defaultValue={filterValues?.category?.depth0}
          onChange={val => handleChangeFilterCategory('depth0', val)}
          isShowArrow
        />
      </SelectWrapper>
      <SelectWrapper>
        <label>Select Depth-1 Category</label>
        <Select
          notReload={filterValues?.category?.depth0 !== 'all'}
          options={depth1Options}
          placeholder='Select depth-1 category'
          defaultValue={filterValues?.category?.depth1}
          onChange={val => handleChangeFilterCategory('depth1', val)}
          isShowArrow
        />
      </SelectWrapper>
      <SelectWrapper>
        <label>Select Depth-2 Category</label>
        <Select
          notReload={filterValues?.category?.depth0 !== 'all' && filterValues?.category?.depth1 !== 'all'}
          options={depth2Options}
          placeholder='Select depth-2 category'
          defaultValue={filterValues?.category?.depth2}
          onChange={val => handleChangeFilterCategory('depth2', val)}
          isShowArrow
        />
      </SelectWrapper>
    </Container>
  )
}
